import type Highcharts from "highcharts";
import { formatStorageSize } from "utils/helpers";
import { Top5BucketItem } from "./types";

export function composeTop5BucketsChartOptions(items: Top5BucketItem[], barColor: string): Highcharts.Options {
  const top5 = items.slice(0, 5);
  const maxValue = Math.max(...(top5.map((item) => item.value) ?? [0]));

  return {
    chart: {
      type: "bar",
      height: 260,
      backgroundColor: "transparent",
      style: {
        fontFamily: "Dustin Sans",
      },
    },
    exporting: { enabled: false },
    title: { text: "" },
    credits: { enabled: false },
    legend: { enabled: false },

    tooltip: {
      useHTML: true,
      formatter: function () {
        return `
          <span style="font-family: Dustin Sans;">
            <span style="font-size: 12px; color: #595959;">${this.key}</span><br />
            <span><b>${formatStorageSize(Number(this.y))}</b></span>
          </span>
        `;
      },
    },

    xAxis: {
      categories: top5.map((item) => item.name),
      labels: {
        align: "left",
        x: 4,
        y: 4,
        style: {
          fontSize: "12px",
          fontFamily: "Dustin Sans",
          color: "#333",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        },
      },
      lineWidth: 1,
      lineColor: "#000",
    },

    yAxis: {
      max: maxValue ? maxValue * 1.1 : 1,
      title: { text: undefined },
      labels: {
        enabled: true,
      },
      gridLineWidth: 0,
      lineWidth: 1,
      lineColor: "#000",
      tickWidth: 0,
    },

    plotOptions: {
      bar: {
        animation: {
          duration: 1000,
        },
        pointPadding: 0.08,
        groupPadding: 0.12,
        borderRadius: 0,
        dataLabels: {
          enabled: false,
          inside: false,
          crop: false,
          overflow: "allow",
          formatter: function () {
            return formatStorageSize(Number(this.y));
          },
          style: {
            fontSize: "12px",
            fontFamily: "Dustin Sans",
            fontWeight: "400",
            color: "#333",
            textOutline: "none",
          },
        },
      },
      series: {
        stacking: "normal",
        states: {
          hover: {
            enabled: true,
          },
        },
      },
    },

    series: [
      {
        type: "bar",
        data: top5.map((item) => ({
          y: item.value,
          color: barColor,
          name: item.name,
        })),
      },
    ],
  };
}
